import styled, { keyframes } from "styled-components"

import { spacing, colors } from "@izettle/otto"

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const spinnerSizes = {
  auto: "1em",
  large: spacing.xLarge,
  normal: spacing.large,
  small: spacing.small,
  xSmall: spacing.xSmall,
}

const fillColors = {
  ...colors.brand,
  white: colors.icon.inverted,
  highlight: colors.icon.highlight,
}

type Sizes = keyof typeof spinnerSizes
type Colors = keyof typeof fillColors
type GetSize = (props: ISpinnerSimpleProps) => string
const getSize: GetSize = ({ size }) => spinnerSizes[size ?? "normal"]

export type ISpinnerSimpleProps = {
  size?: Sizes
  color?: Colors
}

const speed = "0.8s"
const thickness = "2px"

const getFillColor = ({ color }: ISpinnerSimpleProps) => fillColors[color ?? "mint"]

export const SpinnerSimple = styled.i<ISpinnerSimpleProps>`
  animation: ${spin} ${speed} infinite linear;
  position: relative;
  display: block;
  width: ${getSize};
  height: ${getSize};
  flex-shrink: 0;

  /* stylelint-disable-next-line @izettle/border-color */
  border: ${thickness} solid ${getFillColor};
  border-top-color: transparent !important;
  background-color: transparent;
  border-radius: 50%;
`
